module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/DefinitionSection/car-insurance-ee8f95582f94b8c058993b10cefc25dd.png";